/* eslint-disable no-continue */
function loadScripts(scripts = []) {
  setTimeout(() => {
    try {
      for (let index = 0; index < scripts.length; index++) {
        // caso seja undefined, renderiza o script (pode ainda não ter sido configurado no banco)
        if (scripts[index]?.enabled === false) continue;

        const script = document.createElement('script');

        Object.keys(scripts[index]).forEach((key) => {
          if (key !== 'textContent') {
            script.setAttribute(key, scripts[index][key]);
          }

          if (key === 'textContent') {
            script.textContent = scripts[index][key];
          }
        });

        document.body.appendChild(script);
      }
    } catch (error) {
      console.log('load mongo scripts failed');
    }
  }, 2000);
}

export default loadScripts;
